import { useQuery } from '@tanstack/react-query'
import { fetchFactionWithMembers, factionKeys } from '@/services/factions'

export function useFactionWithMembers(factionId: string | undefined) {
  const factionQuery = useQuery({
    queryKey: factionKeys.detailWithMembers(factionId!),
    queryFn: () => fetchFactionWithMembers(factionId!),
    enabled: !!factionId,
  })

  return {
    faction: factionQuery.data,
    isLoading: factionQuery.isLoading,
    error: factionQuery.error,
  }
}
